import { field, relation,text } from '@nozbe/watermelondb/decorators';
import { TRUSTED_LIST_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class TrustedList extends Model {
    static table = TRUSTED_LIST_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('number') number;
    @text('name') name;
    @text('type') type;

    @relation('business', 'business_id') business;
};
